import { useGlobalStateStore } from "@/store/GlobalState"
import { Grid, Tooltip } from "@material-ui/core"
import React from "react"
import { InfoOutlined as InfoIcon } from "@material-ui/icons"
import { colors } from "@/styles/colors"
import useStyles from "@/components/ChannelRestrictionGate/styles"
import HardCoded from "@/services/HardCoded"

type ChannelRestrictionGateVariants = "hover" | "with-icon"

type ChannelRestrictionGateProps = {
	children: React.ReactNode,
	otherRulesToDisabled?: boolean,
	tooltipConfig?: {
		tooltipText?: string
		tooltipDisableRules?: boolean
	}
	variant: ChannelRestrictionGateVariants
}

const ChannelRestrictionGate: React.FC<ChannelRestrictionGateProps> = (props) => {
	const {
		children,
		otherRulesToDisabled,
		tooltipConfig,
		variant
	} = props

	const classes = useStyles()

	const { instance } = useGlobalStateStore()
	const canImportBots = HardCoded.checkFeatureFlag("canImportBotsOnWaba")
	const isWabaChannel = instance.current_channel_type === "waba" && !canImportBots

	const channelDisabled = isWabaChannel ? (otherRulesToDisabled ?? true) : false

	const tooltipMessage = channelDisabled
		? "Essa funcionalidade está indisponível na WABA."
		: tooltipConfig?.tooltipText ?? ""
	const childDisabled = React.isValidElement(children) ? Boolean((children.props as { disabled?: boolean })?.disabled) : false
	const isDisabled = channelDisabled || childDisabled

	const getComponentVariant = (variant: ChannelRestrictionGateVariants) => {
		const componentVariants: Record<ChannelRestrictionGateVariants, React.ReactElement> = {
			hover: (
				<Tooltip
					title={tooltipMessage}
					disableHoverListener={isWabaChannel ? false : tooltipConfig?.tooltipDisableRules}
				>
					<span style={{ flex: 1 }}>
						{React.cloneElement(children as React.ReactElement, {
							disabled: isDisabled,
							isDisabled: isDisabled,
							disable: isDisabled
						})}
					</span>
				</Tooltip>
			),
			"with-icon": (
				<Grid
					container
					className={classes.container}
					justifyContent="space-between"
					alignItems="center"
				>
					<span style={{ flex: 1 }}>
						{React.cloneElement(children as React.ReactElement, {
							isDisabled: isDisabled,
							disabled: isDisabled,
							disable: isDisabled
						})}
					</span>

					{isDisabled && (
						<Tooltip
							title={tooltipMessage}
							disableHoverListener={!isDisabled || tooltipConfig?.tooltipDisableRules}
						>
							<InfoIcon className={classes.infoIconSize} htmlColor={colors.gray[400]} />
						</Tooltip>
					)}
				</Grid>
			)
		}

		return componentVariants[variant]
	}

	return (
		<>
			{getComponentVariant(variant)}
		</>
	)
}

export default ChannelRestrictionGate
